<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="room">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            体检项目
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="info" :disabled="disabledInfo" @click.native="handleInfo">详情</el-button>
                    <!-- <el-button type="info"  @click.native="handleSetUp">批量设置</el-button> -->
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            :clearable='false'
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;margin:0 5px;">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <!-- <el-table
                        ref="multipleTable"
                        :data="tableData"
                        style="width: 100%"
                         :height="th" border
                         highlight-current-row @row-click='rowClick'>
                         <el-table-column
                            type="selection"
                            width="55">
                            </el-table-column> -->
                    <el-table :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>

                        <el-table-column prop="remarks" label="体检结果"></el-table-column>

                        <el-table-column prop="testTime" :formatter="timefilter" label="体检时间"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </template>
            </div>

        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>
        <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="showModalInfo=false" v-on:getList="getList"></Info>
        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeGetElderly="showModalGetElderly=false" v-on:openAdd="openAdd"></GetElderly>
    </div>
</template>

<script>
    import GetElderly from "./GetElderly";
    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Info from "./Info";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                disabledInfo:true,
                showModalAdd:false,
                showModalGetElderly:false,
                showModalInfo:false,
                elderlyName:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                title:'',
                selectInfo:'',
                datetimerangeValue:[],
                tagSelect:'',
                status:-1,
                statusValue:[[-1,'全部状态'],[1,'正常'],[2,'废弃']],
                tagSelectValue:[[1,'是'],[2,'否']],
                multipleSelection:[]
            }
        },
        components:{
            Add,Info,GetElderly
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                var end= new Date();
                var start=new Date(end.getTime() + 1000 * 60 * 60 * 24 * 30);
                end=new Date(end.getTime() - 1000 * 60 * 60 * 24 * 30)
                this.datetimerangeValue=[end,start];
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                val.forEach(element => {
                    this.multipleSelection.push(element.testItemCode)
                });
            },
            openAdd(data){
                this.showModalAdd=true
                this.$refs.myAdd.init(data);
            },
            timefilter(row,index,column){
                return timefilters(column).slice(0,10)
            },
            handleInfo() {
                this.$refs.myInfo.init(this.selectInfo);
                this.showModalInfo = !this.showModalInfo;
            },
            toggleModalAdd:function(){
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"TestRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        startTime:timefilters(this.datetimerangeValue[0]).slice(0,10),
                        endTime:timefilters(this.datetimerangeValue[1]).slice(0,10),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.disabledInfo=true
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            rowClick(row){
                this.disabledInfo=true
                this.selectInfo=row
                this.disabledInfo=false
            }
        }
    }
</script>

<style lang='scss' scoped>
    .room /deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
</style>
